module.exports = __webpack_public_path__ + "img/6-sdg-border@2x.53697164.png";